import { Box } from '@factorialco/deprecated-design-system'
import { Features } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import { MissingFeatureEmptyState } from 'modules/project_management/components/upsells/MissingFeatureEmptyState'

interface UpsellWizardGenericStepProps {
  featureRequested: Features
  requestSource: string
}

export const UpsellWizardGenericStep = ({
  featureRequested,
  requestSource,
}: UpsellWizardGenericStepProps) => {
  return (
    <Box flexDirection="column" gap="s24" width="s400">
      <Box
        padding="s24"
        gap="s24"
        justifyContent="center"
        alignItems="center"
        borderRadius={{ all: 'abs008' }}
        border={{
          all: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }}
        background="grey000White"
      >
        <MissingFeatureEmptyState
          featureRequested={featureRequested}
          requestSource={requestSource}
          description={i18n.t('project_management.upselling.settings')}
          variant="card"
        />
      </Box>
    </Box>
  )
}
